import type { AttachmentMetadata } from "../../shared/BuilderUI/Media/AttachmentContext";
import { uploadTemplateAttachment } from "../services/uploadTemplateAttachment";
import { urlToFile } from "./urlToFile";

export const uploadStaticImage = async (
  imageUrl: string,
  filename: string,
): Promise<AttachmentMetadata> => {
  const file = await urlToFile(imageUrl, filename);
  const result = await uploadTemplateAttachment({ file });

  return {
    url: result.url,
    signed_id: result.signed_id,
  };
};
